<template>
  <div class="feng-tuoyuan-scan">
    <div class="hero-banner">
      <img class="banner-img" src="/static/images/fty/banner.png" alt="丰驼源 banner">
      <img class="brand-logo" src="/static/images/fty/logo.png" alt="丰驼源 logo">
    </div>

    <div class="page-body">
      <div class="title-text">点击下方按钮扫码查询</div>

      <div class="scan-entry" @click="handleScanClick">
        <img class="scan-entry-img" src="/static/images/fty/scan.png" alt="扫码查询">
      </div>

      <div class="manual-tip">若二维码破损请输入数码查询</div>

      <div class="query-box">
        <input
          v-model="antiCode"
          @input="handleCodeInput"
          class="code-input"
          type="tel"
          maxlength="16"
          placeholder="请输入16位查询码"
        >
        <button class="query-btn" type="button" @click="submitQuery()">查询</button>
      </div>

      <wx-open-launch-weapp
        v-if="miniAppId && miniAppOriginalId && miniAppPage"
        class="shop-entry"
        :appid="miniAppId"
        :username="miniAppOriginalId"
        :path="miniAppPage"
      >
        <script type="text/wxtag-template">
          <img
            src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/to-shop-a1bbed85527840e2b7f70d80ae7f8498.png"
            alt="进入官方商城"
            style="display:block;width:100%;height:auto;"
          />
        </script>
      </wx-open-launch-weapp>
      <div v-else class="shop-entry">
        <img class="shop-entry-img" src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/to-shop-a1bbed85527840e2b7f70d80ae7f8498.png" alt="进入官方商城">
      </div>
    </div>
  </div>
</template>

<script>
import { getJSSDK, getScoreConfig } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'FengTuoYuanScan',
  data() {
    return {
      antiCode: '',
      appId: process.env.ENV_NUM === '1' ? 'wx75dda783f234b0a9' : 'wx885161c495be58a3',
      deptId: process.env.ENV_NUM === '1' ? '119' : '1040',
      isWxReady: false,
      scoreConfig: null,
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: ''
    }
  },
  mounted() {
    this.getWxJs()
  },
  methods: {
    handleCodeInput() {
      this.antiCode = (this.antiCode || '').replace(/\D/g, '').slice(0, 16)
    },
    submitQuery(code) {
      const queryCode = (code || this.antiCode || '').replace(/\D/g, '').slice(0, 16)
      this.antiCode = queryCode
      if (queryCode.length !== 16) {
        alert('请输入16位查询码')
        return
      }
      window.location.href = `${window.location.origin}/fty/result?c=${encodeURIComponent(queryCode)}`
    },
    handleScanClick() {
      if (!this.isWxReady) {
        alert('微信扫码能力初始化中，请稍后重试')
        return
      }
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrCode'],
        success: res => {
          const scanResult = res.resultStr || ''
          let scanCode = scanResult
          if (scanResult.startsWith('http')) {
            const parts = scanResult.split('/')
            scanCode = parts[parts.length - 1] || ''
          }
          this.submitQuery(scanCode)
        },
        fail: err => {
          console.error('扫码失败:', err)
          alert('打开扫码失败，请稍后重试')
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideMenuItems',
            'showOptionMenu',
            'hideOptionMenu',
            'closeWindow',
            'scanQRCode'
          ]
        })
        wx.ready(() => {
          this.isWxReady = true
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
          this.loadScoreConfig()
        })
        wx.error(err => {
          this.isWxReady = false
          console.error('微信 JS-SDK 初始化失败:', err)
        })
      }).catch(err => {
        this.isWxReady = false
        console.error('获取微信 JS-SDK 失败:', err)
        alert('获取微信授权失败，请稍后重试')
      })
    },
    loadScoreConfig() {
      getScoreConfig(this.deptId).then(res => {
        const data = res && res.data ? res.data.data : null
        if (!data) {
          return
        }
        this.scoreConfig = data
        this.shopUrl = data.shopUrl || ''
        if (this.shopUrl) {
          const shopInfo = this.shopUrl.split('|')
          this.miniAppId = shopInfo[0] || ''
          this.miniAppOriginalId = shopInfo[1] || ''
          this.miniAppPage = shopInfo[2] || ''
        }
      }).catch(err => {
        console.error('获取积分配置失败:', err)
      })
    }
  }
}
</script>

<style scoped>
.feng-tuoyuan-scan {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.hero-banner {
  flex: 0 0 auto;
  position: relative;
  width: 100%;
  overflow: hidden;
  border-bottom-left-radius: clamp(28px, 6.4vw, 40px);
  border-bottom-right-radius: clamp(28px, 6.4vw, 40px);
}

.banner-img {
  display: block;
  width: 100%;
  height: clamp(170px, 31vh, 260px);
  object-fit: cover;
  object-position: center;
}

.brand-logo {
  position: absolute;
  left: 50%;
  bottom: clamp(14px, 3.8vw, 22px);
  width: clamp(112px, 33vw, 132px);
  transform: translateX(-50%);
}

.page-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: clamp(14px, 3vh, 20px) clamp(16px, 5.4vw, 20px) clamp(16px, 4vh, 24px);
}

.title-text {
  font-size: clamp(17px, 5vw, 20px);
  line-height: 1.45;
  font-weight: 500;
  color: #4a4a4a;
  text-align: center;
}

.scan-entry {
  margin-top: 0;
}

.scan-entry-img {
  display: block;
  width: clamp(118px, 36vw, 138px);
  height: clamp(118px, 36vw, 138px);
}

.manual-tip {
  margin-top: 0;
  font-size: clamp(14px, 4.2vw, 16px);
  line-height: 1.45;
  color: #4a4a4a;
  text-align: center;
}

.query-box {
  width: 70vw;
  max-width: 100%;
  margin-top: 0;
  display: flex;
  align-items: center;
  border-radius: clamp(14px, 4vw, 18px);
  overflow: hidden;
  background: rgb(249, 250, 251);
}

.code-input {
  flex: 1;
  height: clamp(37px, 10.5vw, 44px);
  padding: 0 clamp(14px, 4vw, 18px);
  border: 0;
  background: transparent;
  font-size: clamp(14px, 4vw, 15px);
  color: #303133;
  outline: none;
}

.code-input::placeholder {
  color: #b7bec9;
}

.query-btn {
  width: clamp(82px, 24vw, 92px);
  height: clamp(37px, 10.5vw, 44px);
  border: 0;
  border-radius: 0 clamp(14px, 4vw, 18px) clamp(14px, 4vw, 18px) 0;
  background: rgb(76, 189, 200);
  color: #ffffff;
  font-size: clamp(15px, 4.4vw, 17px);
  font-weight: 600;
  letter-spacing: 1px;
}

.shop-entry {
  width: 50vw;
  max-width: 100%;
  margin-top: 0;
}

.shop-entry-img {
  display: block;
  width: 100%;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/FengTuoYuan/Scan.vue